// extracted by mini-css-extract-plugin
module.exports = {"cover":"x1sS9wb","video":"nmYWLkb","video-container":"_31FCGbi","videoContainer":"_31FCGbi"};